import React from 'react';
import SVGIcon from '../../../components/SVGIcon/SVGIcon';
import { SetToggleButton } from './ListViewSetToggle.style';

interface ListViewSetToggleProps {
  /* Whether the members of the set are listed right now */
  expanded: boolean;
  onToggle: () => void;
  /* The set's own name, which the button's label says it opens or closes -
     even where the button itself is labelled with something else */
  setName: string;
  /* What the set is labelled with here: its name in the table and on a
     member of a set, the summary line on its card */
  children: React.ReactNode;
}

/* The chevron that opens and closes one set, with the label it sits in front
 * of. Both view modes use it, so the two agree on which way the chevron points
 * and on what the button is called. */
const ListViewSetToggle = ({
  expanded,
  onToggle,
  setName,
  children
}: ListViewSetToggleProps) => (
  <SetToggleButton
    type="button"
    aria-expanded={expanded}
    aria-label={
      expanded
        ? i18n('Hide the resources in {setName}', { setName })
        : i18n('Show the resources in {setName}', { setName })
    }
    onClick={onToggle}
    data-test-list-view-set-toggle
    data-test-expanded={expanded}
  >
    {/* In the icon sprite, 'expand-more' is the chevron pointing down and
        'expand-less' the one pointing right */}
    <SVGIcon icon={expanded ? 'expand-more' : 'expand-less'} size="inherit" />
    {children}
  </SetToggleButton>
);

export default ListViewSetToggle;
